import {
    GET_FITCATEGORY_ERROR,
    GET_FITCATEGORY_REQUEST,
    ADD_FITCATEGORY_ERROR, ADD_FITCATEGORY_SUCCESS, ADD_FITCATEGORY_REQUEST,
    UPDATE_FITCATEGORY_REQUEST, UPDATE_FITCATEGORY_ERROR, UPDATE_FITCATEGORY_SUCCESS,
    DELETE_FITCATEGORY_REQUEST, DELETE_FITCATEGORY_SUCCESS, DELETE_FITCATEGORY_ERROR, GET_FITCATEGORY_SUCCESS,
    GET_FIT_CATEGORY_CHANGE_REQUEST,
    GET_FIT_CATEGORY_CHANGE_SUCCESS,
    GET_FIT_CATEGORY_CHANGE_ERROR,
    GET_FITCATEGORYNEW_REQUEST,
    GET_FITCATEGORYNEW_SUCCESS,
    GET_FITCATEGORYNEW_ERROR
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");
export const getFitCategory = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_FITCATEGORY_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/fit_category`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id: menu_id ? menu_id : null }
    })
        .then((response) => {
            return dispatch({ type: GET_FITCATEGORY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_FITCATEGORY_ERROR,
                payload: error.response,
            });
        });
};

export const addFitCategory = (token, data, menu_id) => (dispatch) => {
    dispatch({ type: ADD_FITCATEGORY_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/fit_category`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { fit_category_name: data.fitCategoryName, is_active: data.check, menu_id },
    })
        .then((response) => {

            return dispatch({ type: ADD_FITCATEGORY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_FITCATEGORY_ERROR,
                payload: error.response,
            });
        });
};
export const updateFitCategory = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_FITCATEGORY_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/fit_category/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { fit_category_name: data.fitCategoryName, is_active: data.check },
    })
        .then((response) => {

            return dispatch({ type: UPDATE_FITCATEGORY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_FITCATEGORY_ERROR,
                payload: error.response,
            });
        });
};

export const deleteFitCategory = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_FITCATEGORY_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/fit_category/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_FITCATEGORY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_FITCATEGORY_ERROR,
                payload: error.response,
            });
        });
};

export const getFitChange = (token, gender_id) => (dispatch) => {
    dispatch({ type: GET_FIT_CATEGORY_CHANGE_REQUEST });
    let data = {
        gender_id: gender_id === "All" ? null : gender_id,
    }
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/FitCategoryByGender`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: data
    })
        .then((response) => {
            return dispatch({ type: GET_FIT_CATEGORY_CHANGE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_FIT_CATEGORY_CHANGE_ERROR,
                payload: error.response,
            });
        });
};

export const getFitCategoryNew = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_FITCATEGORYNEW_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/fit_category_new`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id: menu_id ? menu_id : null  }
    })
        .then((response) => {
            return dispatch({ type: GET_FITCATEGORYNEW_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_FITCATEGORYNEW_ERROR,
                payload: error.response,
            });
        });
};